// extracted by mini-css-extract-plugin
module.exports = {"ButtonComplete":"CommunicationCompletionButton_ButtonComplete__1qRf6","ButtonReactivate":"CommunicationCompletionButton_ButtonReactivate__2MZaD"};